import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiLoader } from "@miplatform/components";
import { useRouter } from "@miplatform/hooks";
import { Box } from "@mui/material";
import { DispatchCalendarRenderer } from "./Scheduler/DispatchCalendarRenderer";
import { useScheduleViewModel } from "./useScheduleViewModel";

export function Schedule() {
  const router = useRouter();
  const { id: calendarSetId } = router.params;
  const {
    loading,
    getCalendarSet,
    selectedCalendarConfig,
    calendarTabs,
    handleActiveTabChange,
    updateCalendarCounts,
    activeTab,
    calendarSet,
  } = useScheduleViewModel(calendarSetId);

  const { classes } = useStyles();

  useEffect(() => {
    getCalendarSet();
  }, [calendarSetId]);

  // FIXME: This is just a temporary thing we need remove this once we know what to show in this situation
  if (!selectedCalendarConfig) {
    if (loading) {
      return (
        <Box className={classes.loadingContainer}>
          <MiLoader isLoading />
        </Box>
      );
    }
    return <Box>Configuration Not Found</Box>;
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.mainContent}>
        <DispatchCalendarRenderer
          config={selectedCalendarConfig}
          loading={loading}
          onRefresh={getCalendarSet}
          tabs={calendarTabs}
          handleActiveTabChange={handleActiveTabChange}
          updateCalendarCounts={updateCalendarCounts}
          activeTab={activeTab}
          calendarSet={calendarSet}
        />
      </Box>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    backgroundColor: theme.palette.grey.lightAccent,
    borderTop: `1px solid ${theme.palette.grey.accent}`,
    display: "flex",
    flex: 1,
    overflow: "hidden",
  },
  loadingContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.common.white,
  },
  mainContent: {
    flex: 1,
    width: "100%",
  },
}));
